// define profile reducers.

import ProfileConst from '../constants/profile.constants';

const ProfileReducer = (state = {}, action) => {
  const initialState = state;
  switch (action.type) {
    case ProfileConst.CUSTOM_USER_ATTRIBUTES_VALUE:
      initialState.userAttributes = initialState.userAttributes.map((items) => {
        if (items.id === action.catId) {
          (items.attributes).map((row) => {
            if (row.id == action.cusId) {
              row.ca_value = action.value;
            }
            return row;
          });
        }
        return items;
      });
      state = { ...state, initialState };
      break;
    case ProfileConst.ADD_USER_TIME_OFF:
      if (Object.keys(action.value).length) {
        initialState.userTimeOff.unshift(action.value);
        state = Object.assign({}, state, initialState);
      }
      break;
    case ProfileConst.UPDATE_USER_TIME_OFF:
      initialState.userTimeOff = initialState.userTimeOff.map((item) => {
        if (item.id == action.tempid) {
          item.end_date = action.value.endDate;
          item.start_date = action.value.startDate;
        }
        return item;
      });
      state = { ...state, initialState };
      break;
    case ProfileConst.DELETE_USER_TIME_OFF:
      initialState.userTimeOff = initialState.userTimeOff.filter(obj => (obj.id != action.id));
      state = { ...state, initialState };
      break;

    default:
      break;
  }
  return state;
};

export default ProfileReducer;
